import API from "./axios"
import { waitForTenantSlug } from "../utils/waitForTenantSlug"

export async function getTenantDetails() {
  try {
    const tenantSlug = await waitForTenantSlug()
    const { data } = await API.get(`/v1/public/tenants/${tenantSlug}`)
    return data
  } catch (error) {
    console.error("Error fetching tenant details:", error)
    throw error
  }
}

export async function getAllTenantDetails() {
  const { data } = await API.get(`/v1/public/tenants`)
  return data
}

export async function getBranches(
  page = 1,
  limit = 10,
  search = "",
  status = "",
  tenantId = "",
) {
  try {
    let url = `/v1/branches?page=${page}&limit=${limit}`

    if (search) {
      url += `&search=${encodeURIComponent(search)}`
    }

    if (status) {
      url += `&is_active=${status}`
    }
    if (tenantId !== "") {
      url += `&tenant_id=${tenantId}`
    }

    const { data } = await API.get(url)
    return data
  } catch (error) {
    console.error("Error fetching branches:", error)
    throw error
  }
}

export async function getTenantById(tenantId) {
  const res = await API.get(`/v1/tenants/${tenantId}`)
  return res.data?.data
}

export async function getBranchById(branchId) {
  try {
    const { data } = await API.get(`/v1/branches/${branchId}`)
    return data?.data
  } catch (error) {
    console.error("Error fetching branch by ID:", error)
    throw error
  }
}

export async function getAdminAllTenantDetails() {
  const { data } = await API.get(`/v1/tenants?limit=all`)
  return data
}

export async function createTenant(payload) {
  const { data } = await API.post("v1/tenants", payload, {
    headers:
      payload instanceof FormData
        ? { "Content-Type": "multipart/form-data" }
        : undefined,
  })
  return data
}

export async function getAllTenants() {
  try {
    const { data } = await API.get(`/v1/tenants?limit=all`)
    return data?.data || data || []
  } catch (error) {
    console.error("Error fetching all tenants:", error)
    throw error
  }
}

export async function createTenantInquiry(payload) {
  const { data } = await API.post(
    "v1/public/inquiries/partner-with-us",
    payload,
  )
  return data
}
export async function updateTenantDetails(tenantId, payload) {
  const { data } = await API.patch(`/v1/tenants/${tenantId}`, payload, {
    headers:
      payload instanceof FormData
        ? { "Content-Type": "multipart/form-data" }
        : undefined,
  })

  return data
}

export async function updateBranch(branchId, updateData, tenantId) {
  try {
    const headers = {}

    if (tenantId) {
      headers["X-Tenant-ID"] = tenantId
    }

    const { data } = await API.patch(`/v1/branches/${branchId}`, updateData, {
      headers,
    })
    return data
  } catch (error) {
    console.error("Error updating branch:", error)
    throw error
  }
}
